<div class="general-layout">
  <div>
    <app-header></app-header>
  </div>
  <div class="content-layout">
    <main class="scroll" id="interno">
      <div class="information">
        <router-outlet ></router-outlet>
      </div>
      <aside>
        <app-accesibility></app-accesibility>
      </aside>
    </main>
  </div>
  <div class="linea">
    <app-footer></app-footer>
  </div>
</div>
